import { render, staticRenderFns } from "./SgCategorySelect.vue?vue&type=template&id=09cafba8&scoped=true&"
import script from "./SgCategorySelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./SgCategorySelect.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SgCategorySelect.vue?vue&type=style&index=0&id=09cafba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cafba8",
  null
  
)

export default component.exports